import { render, staticRenderFns } from "./FreeItem.vue?vue&type=template&id=6717c448&scoped=true"
import script from "./FreeItem.vue?vue&type=script&lang=js"
export * from "./FreeItem.vue?vue&type=script&lang=js"
import style0 from "./FreeItem.vue?vue&type=style&index=0&id=6717c448&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6717c448",
  null
  
)

export default component.exports